import { Link } from "@heroui/react";
import { splitTextByUrls } from "@/utils/linkify";

export type LinkifiedTextProps = {
  text: string;
  linkClassName?: string;
};

export function LinkifiedText({ text, linkClassName }: LinkifiedTextProps) {
  return (
    <>
      {splitTextByUrls(text).map((segment, index) =>
        segment.type === "url" ? (
          <Link
            key={`${index}-${segment.value}`}
            href={segment.value}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {segment.value}
          </Link>
        ) : (
          <span key={`${index}-text`}>{segment.value}</span>
        ),
      )}
    </>
  );
}
